import { ArtifactType, Solicitacao } from '@/models/Solicitacao';

import api from '@/sevices/api';

import { ProtocoloExecutado } from '@/models/ProtocoloExecutado';
import {
  RuntimeOptions,
  runtimePathPrefix,
} from '@/features/runtime/utils/helpers';
import { PassoExecutado } from '@/models/PassoExecutado';
import { APIResult } from '@/types/Api';

interface CancelAllResponse {
  results: Solicitacao[];
  solicitacoes: number[];
}

interface AddItemOptions {
  tipo: ArtifactType;
  resource: fhir4.FhirResource;
  protocolo: ProtocoloExecutado;
}

interface IncludeItemOptions {
  tipo: ArtifactType;
  resource: fhir4.FhirResource;
  passo: PassoExecutado;
}

interface UpdateItemOptions {
  id: string;
  tipo: ArtifactType;
  resource: fhir4.FhirResource;
  opts?: RuntimeOptions;
}

async function create({
  tipo,
  resource,
  protocolo,
}: AddItemOptions): Promise<Solicitacao> {
  return (
    await api.post<Solicitacao>(
      `${runtimePathPrefix(protocolo)}/protocolos-executados/${
        protocolo.id
      }/solicitacoes/`,
      {
        tipo,
        incluir_bundle: false,
        pedido: resource,
      },
    )
  ).data;
}

async function include({
  tipo,
  resource,
  passo,
}: IncludeItemOptions): Promise<Solicitacao> {
  return (
    await api.post<Solicitacao>(
      `${runtimePathPrefix(passo)}/passos-executados/${passo.id}/solicitacoes/`,
      {
        tipo,
        incluir_bundle: false,
        pedido: resource,
      },
    )
  ).data;
}

async function requestAll(
  items: Solicitacao[],
  passo: PassoExecutado,
): Promise<Solicitacao[]> {
  return (
    await api.post<APIResult<Solicitacao>>(
      `${runtimePathPrefix(passo)}/passos-executados/${
        passo.id
      }/solicitar-artefatos/`,
      {
        solicitacoes: items.map(item => item.id),
      },
    )
  ).data.results;
}

async function cancelAll(
  items: Solicitacao[],
  passo: PassoExecutado,
): Promise<CancelAllResponse> {
  const artefatos = (
    await api.post<CancelAllResponse>(
      `${runtimePathPrefix(passo)}/passos-executados/${
        passo.id
      }/cancelar-artefatos/`,
      {
        solicitacoes: items.map(item => item.id),
      },
    )
  ).data;

  return artefatos;
}

async function destroy(
  itemID: string,
  opts: RuntimeOptions = {},
): Promise<void> {
  await api.delete(`${runtimePathPrefix(opts)}/solicitacoes/${itemID}/`);
}

async function update({
  id: itemID,
  tipo,
  resource,
  opts = {},
}: UpdateItemOptions): Promise<Solicitacao> {
  return (
    await api.put<Solicitacao>(
      `${runtimePathPrefix(opts)}/solicitacoes/${itemID}/`,
      {
        tipo,
        incluir_bundle: false,
        pedido: resource,
      },
    )
  ).data;
}

export default {
  create,
  include,
  requestAll,
  cancelAll,
  destroy,
  update,
};
